import { encode } from 'base-64';
import hoistNonReactStatics from 'hoist-non-react-statics';
import PropTypes from 'prop-types';
import React from 'react';

const withUniqueId = (prefix = '') => {
  const uidCounter = {
    counter: 0,
    get count() {
      return ++this.counter;
    },
  };

  return Component =>
    hoistNonReactStatics(
      class WithUniqueId extends React.PureComponent {
        static displayName = `withUniqueId(${
          Component.displayName || Component.name
        })`;

        uid = `${prefix}${encode(WithUniqueId.displayName).replace(
          /[^A-z0-9]/g,
          '',
        )}${uidCounter.count}`;

        render() {
          return <Component {...this.props} uid={this.uid} />;
        }
      },
      Component,
    );
};

withUniqueId.props = {
  uid: PropTypes.string.isRequired,
};

export default withUniqueId;
